'use client';
import { usePostHog } from 'posthog-js/react';

const events = [
  'NPS Submit',
  'Paywall Shown',
  'Welcome Slide Start',
  'Cancel Plan Clicked',
  'Invite and Earn Clicked',
  'noteContentsUpdated',
  'supportLinkClicked',
  'actionMenuItemSelected',
  'citationAddedLibrary',
  'citationAddedDocument',
  'textEditorContentsExportedPDF',
  'autocompleteUsed',
  'Account Sharing Detected',
  'wordCountLimitHit',
  'textEditorContentsCopied',
  'userLogin',
  'Sign In',
  'importLimitHit',
  'websiteIngested',
  'fileUploadFailed',
  'chatbotCreated',
  'messageGenerated',
  'messageGenerationStopped',
  'textEditorContentsExportedHTML',
  'textEditorContentsExportedWord',
  'textEditorContentsExportedLaTeX',
  'pageLimitExceeded',
  'Onboarding Complete',
  'dailyPageLimitHit',
  'Subscription Upgraded',
  'newCreateNoteClicked',
  'Subscription Renew Clicked',
  'Billing Switched to Yearly',
  'goToCitation',
  'languageInputChanged',
  'modelChangeAttemptByFree',
  'maxLengthChangeAttemptByFree',
  'maxLengthChanged',
  'textEditorContentsDuplicated',
  'textEditorContentsDeleted',
  'sidebar_open',
  'sidebar_closed',
  'search_menu_shortcut',
  'search_ai_message',
  'search_chatbot_selected',
  'search_create_note',
  'search_import',
  'chat_suggestions_prompt_clicked',
  'chat_suggestions_category_clicked',
  'upsell_banner_purchase_clicked',
  'upsell_banner_closed',
  'upsell_banner_shown',
  'ugc_program_modal_shown',
  'ugc_program_modal_clicked',
  'ugc_program_modal_closed',
  'login_button_clicked',
  'signup_button_clicked',
  'pricingToggled',
  'pricingPlanSelected',
  'share_chatbot_continue',
  'share_chatbot_published',
  'chat_feedback',
  'chat_feedback_copied',
  'recording_attempt_free_plan',
  'group_empty_created',
  'group_chatbot',
  'group_separate',
  'recording_created',
  'recording_start',
  'recording_stop',
  'recording_pause',
  'contact_sales_button_clicked',
  'footer_button_clicked',
  'navbar_button_clicked',
  'free_user_promotion_modal_clicked',
  'free_user_modal_shown',
  'theme_changed',
  'update_name_navbar',
  'relatedChatbotClicked',
  'graph_sidebar_clicked',
  'related_sidebar_opened',
  'info_sidebar_opened',
  'graph_node_clicked',
  'chat_model_change',
  'editor_model_change',
  'attachment_added',
  'referral_banner_clicked',
  'referral_copy_link',
  'referral_paypal_email_set',
  'referral_conversion',
  'referral_link_visited',
  'chat_add_to_library',
  'flashcard_next',
  'flashcard_previous',
  'flashcard_shuffle',
  'flashcard_show_answer',
  'flashcard_show_explanation',
  'flashcard_toggle_hint',
  'add_team_seats',
  'email_CTA_click',
  'email_CTA_unsubscribe_click',
  'referral_venmo_username_set',
  'chat_nothing_context_changed',
  'chat_nothing_created',
  'paywall_banner_clicked',
  'paywall_banner_closed',
  'paywall_banner_shown',
  'referral_notification_clicked',
  'changelog_notification_clicked',
  'changelog_notification_dismissed',
  'changelog_helpmenu_recent_clicked',
  'changelog_helpmenu_full_clicked',
  'onboarding_referral_submit',
  'onboarding_referral_toggle_invites',
  'onboarding_referral_copy_link',
  'checkout_completed',
  'feedback_submit',
  'friend_created',
  'slack_community_clicked',
  'menu_select_chatbot',
  'breakdown_with_ai',
  'non_auth_paper_ingested',
  'public_message_generated',
  'add_to_library',
  'citation_menu_online_search',
  'landing_button_clicked',
  'plus_menu_button_clicked',
  'fun_mode_enabled',
  'fun_mode_disabled',
  'fun_mode_selected',
  'fun_mode_url',
  'annotations_sidebar_opened',
  'related_item_added_to_library',
  'annotation_created',
  'annotation_deleted',
  'annotation_copied',
  'annotation_scrolled_to',
  'annotation_color_updated',
  'annotation_added_to_chat',
  'annotation_comment_copied',
  'annotation_comment_added',
  'annotation_comment_added_to_chat',
  'annotation_comment_updated',
  'annotation_comment_deleted',
  'library_folder_created',
  'library_sort_added',
  'library_filter_added',
  'library_add_clicked',
  'library_column_added',
  'library_chat_open',
  'library_breadcrumb_clicked',
  'zotero_connect',
  'zotero_disconnect',
  'zotero_import',
  'max_length_response_selected',
  'device_account_limit_reached',
  'new_device_added',
] as const;

export type EventType = (typeof events)[number];

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export type TrackFn = (eventName: EventType, payload?: any) => void;

const useAnalytics = () => {
  const posthog = usePostHog();

  const track: TrackFn = (eventName, payload) => {
    posthog.capture(eventName, payload);
  };

  return { track };
};

export default useAnalytics;
